import React, { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { alert_icon } from '../../../assets/images'

const Tabbar = ({ list, total, classes = '', loading = false, ids = [], newPageId = '', alertIcon = '', tabItemClassName, changeHandler = () => {} }) => {
  const [curPageId, setcurPageId] = useState('')
  list = list ? list : new Array(4).fill({})
  const main_total = total || Array(list.length).fill(0)
  total = total ? total.map((val) => (`(${val})`)) : new Array(list?.length ?? 4).fill('')

  const handler = (event) => changeHandler(event.target.id)

  const toggleClasses = (element) => {
    if (element) {
      element.classList.toggle('text-blue-600')
      element.classList.toggle('border-blue-600')
    }
  }

  useEffect(() => {
    toggleClasses(document.getElementById(curPageId))
    toggleClasses(document.getElementById(newPageId))
    setcurPageId(newPageId)
  }, [newPageId])

  const alertSymbol = (count, title) => {
    if(count >= 0){
      return(
        <img src={alert_icon} />
      )
    }else ''
 }

  return (
    <div className={classes}>
      <div className='border-b border-gray-200'>
        <nav className='-mb-px flex justify-start w-full' aria-label='Tabs'>
          {list.map((item, index) => {
            if(item === 'Partially Completed' && (main_total[index] || 0) <= 0) {
              return (
              <>
              </>)
            }
            return (
              <span
                key={item || index}
                onClick={handler}
                id={ids.length > index ? ids[index] : item}
                className={`border-transparent text-gray-500 border-b hover:text-blue-600 hover:border-blue-600  py-2 mr-10 text-center font-semibold text-base cursor-pointer flex flex-row ${tabItemClassName}`}
              >
                {item === alertIcon && parseInt(total[index]?.replace(/[()]/g, '')) > 0 ? <img src={alert_icon} className='pr-1.5 pointer-events-none' height={22} width={22} /> : ''}
                {loading ? <Skeleton width={100} height={25} /> : `${item} ${total[index]}`}
              </span>
            )
          })}
        </nav>
      </div>
    </div>
  )
}

export default Tabbar
